// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"200":"66f2e3e3","453":"a95f937e","645":"25789bd1"}[chunkId] + ".chunk.js";
};